import { NgModule } from '@angular/core';

import { LightsApiService } from '../api';

import { DeviceSysApiService } from './services';
import { SysApiLightsApiService } from './sys-api-lights-api.service';

@NgModule({
	providers: [
		SysApiLightsApiService,
		DeviceSysApiService,
		{
			provide: LightsApiService,
			useClass: SysApiLightsApiService
		}
	]
})
export class SysApiLightsDataAccessModule {}
